<template>
  <div>

       <div class="position-relative">
      <div class="container pt-5" style="margin-top:100px">
        <div class="row justify-content-between align-items-center">

         <h1 class="display-3">Company Profile</h1>
                <p class="lead  ">
                  <b>Universal Tech LLC</b> is as a multi-vendor IT Solution
                  Provider Company focused on providing quality data center
                  hardware, equipment, solutions, and services which have been
                  in operation for the last four years. In fact,we offer IT
                  services and products to achieve the customers business goals.
                  Even more, the company presents an outstanding balance of
                  innovation and peace of mind to your IT solutions whether you
                  want to progress your data center facilities, security, IT
                  infrastructure.
                </p>
                <p class="lead  ">
                  Certainly, we work in a highly collaborative model
                  transforming the way you work and take your business to the
                  next level. Additionally, Customer satisfaction is considered
                  the <em>UTMOST</em> priority to our team, a group of talented,
                  trained and highly experienced experts to provide all smart
                  solution to our customers.
                </p>
        </div>

      </div>
    </div>


    <section class="section section-lg mt--100">
      <div class="container ">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-md-2">
            <a href="tel:1-888-866-4775" target="_blank">
              <img src="img/theme/4.png" class="img-fluid floating"
            /></a>
          </div>
          <div class="col-md-6 order-md-1">
            <div class="pr-md-5">
              <icon
                name="fa fa-heart"
                class="mb-5"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>
              <h3>Our promise</h3>
              <p>
                We’ll bring the following strengths to our work for you as we
                believe that strength comes with simple principles:
              </p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span class="badge mr-3 badge-success badge-circle"
                      ><i class="fa fa-users"></i
                    ></span>
                    <h6 class="mb-0">
                      True collaboration with customers and partners
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span class="badge mr-3 badge-success badge-circle"
                      ><i class="fa fa-underline"></i
                    ></span>
                    <h6 class="mb-0">
                      Complete understanding of customers business
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span class="badge mr-3 badge-success badge-circle"
                      ><i class="ni ni-settings"></i
                    ></span>
                    <h6 class="mb-0">
                      Continuing to finish the job professionally
                    </h6>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <span class="badge mr-3 badge-success badge-circle"
                      ><i class="fa fa-thumbs-up"></i
                    ></span>
                    <h6 class="mb-0">Top quality assurance</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img v-lazy="'img/theme/ban3.png'" class="card-img-top" />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon
                    points="0,52 583,95 0,95"
                    class="fill-default"
                  ></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">
                  Why Universal Tech?
                </h4>
                <p class="lead text-italic text-white">
                  Our expertise, resources, and attention to detail make us
                  stand out and the ideal choice to meet the client’s needs for
                  an infrastructure and security solution.
                </p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <icon
                name="ni ni-satisfied"
                class="mb-5"
                size="lg"
                type="warning"
                shadow
                rounded
              ></icon>

              <h3>Our customers</h3>
              <p class="lead">
                The customers want to excel in every aspect of its business,
                which means it will need to take advantage of the best
                technological tools available in order to gain an edge over its
                competitors. This is the reason you want a company like
                Universal Tech LLC to provide you with a customized solution to
                maximize efficiency and security, minimize cost, and achieve
                your unique goals.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Reliable Service</h2>
            <p class="lead text-white">
              With our 24/7 support, our team can resolve problems in a fast and
              efficient way to keep your business up and to run smoothly. We all
              want to be part of a team that leaves a legacy and remembered for
              years about what we have achieved.
            </p>
            <div class="col-md-12"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg pt-lg-0 section-contact-us">
      <div class="container">
       <!-- <div class="row justify-content-center " >
          <div class="col-lg-8 text-center">
            <h4 class="mb-1 text-white">Want to work with us?</h4>
            <p class="mt-0 text-white">Your project is very important to us.</p>
          </div>
        </div> -->

        <div class="row justify-content-center mt--300  ">
          <div class="col-lg-8">
            <EmailForm></EmailForm>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">
              <span class="text-success"
                >Innovation is our Passion</span
              >
            </h2>
            <p class="lead">
              We approach new technology and continue to innovate. As a result,
              Universal Tech LLC has established and will continue to establish
              a long history for developing and providing high-quality IT
              Solutions.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import EmailForm from "./components/EmailForm";
export default {
  components: {
    EmailForm,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
